import gql from 'graphql-tag';

export default gql`
fragment ProductAttributeOptionAllData on ProductAttributeOption {
    id
    label
    position
    is_active
    is_default
}
`;


// WEBPACK FOOTER //
// ./src/api/graphql/fragments/ProductAttributeOptionAllData.ts